export enum ECountType {
  LOCATION = "L",
  PRODUCT = "P",
}
